import { Badge } from "@/components/primitives/Badge";
import { Button } from "@/components/primitives/Button";
import { Drawer } from "@/components/overlays/Drawer";
import type { FilterDrawerProps } from "./FilterDrawer.types";

export function FilterDrawer({
  open,
  onOpenChange,
  onClose,
  title = "Filters",
  description,
  children,
  activeFiltersCount = 0,
  applyLabel = "Apply filters",
  resetLabel = "Reset all",
  onApply,
  onReset,
  applying,
  footerActions,
  className
}: FilterDrawerProps) {
  return (
    <Drawer
      open={open}
      onOpenChange={onOpenChange}
      onClose={onClose}
      title={
        <span className="bfrs-inline-flex bfrs-items-center bfrs-gap-2">
          {title}
          {activeFiltersCount > 0 && <Badge tone="primary" count={activeFiltersCount} />}
        </span>
      }
      description={description}
      size="sm"
      preventClose={applying}
      className={className}
      footer={
        footerActions ?? (
          <div className="bfrs-flex bfrs-gap-2">
            <Button variant="secondary" fullWidth onClick={onReset} disabled={applying}>
              {resetLabel}
            </Button>
            <Button fullWidth loading={applying} onClick={onApply}>
              {applyLabel}
            </Button>
          </div>
        )
      }
    >
      <div className="bfrs-grid bfrs-gap-4">{children}</div>
    </Drawer>
  );
}
